// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 116,
  argument: "All nations are called upon to praise God for his mercy and truth.",
  verses: [
    { n: 1, text: "Alleluia. O praise the Lord, all ye nations: praise him, all ye people." },
    { n: 2, text: "For his mercy is confirmed upon us: and the truth of the Lord remaineth for ever." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Alleluia. This word is found at the end of the last psalm, in Hebrew. (Haydock) — The captives invite all to thank God for their delivery, which was a most striking figure of the world's redemption, in which sense the apostle (Romans xv. 11.) quotes this psalm, with the holy Fathers, though Ven. Bede puts it in the mouth of Ezechias, after the retrogradation of the sun. Kimchi allows that it regards the times of the Messias. (Calmet) — Praise him. St. Paul reads, magnify him, as the Hebrew means, \"extol\" by your praises. (Berthier) — All are invited to praise, as the redemption is sufficient, (Worthington) and designed for all the posterity of Adam.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Remaineth is not in Hebrew. Mercy and truth confirm us. (Haydock) — The psalmist acknowledges that he also stands in need of them, and St. John assures us, that grace and truth came by Jesus Christ. [John i. 17.] (Berthier) — No promise had been made to the Gentiles (Worthington) by the law; though they were all included in the original promise, Genesis iii. 15. (Haydock) — God hath withdrawn them from idolatry, to impart to them his mercies.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
